import getYear from "date-fns/getYear";
import type { IntlShape } from "react-intl";
import { IPostContextType } from "types/graphqlTypes";

export default function getPageHeadingDetails(contextType: IPostContextType, intl: IntlShape) {
  if (contextType === IPostContextType.IrpfForum) {
    const year = getYear(new Date());

    return {
      title: "Fórum IRPF",
      description: `Crie um tópico no nosso fórum e tire a sua dúvida sobre o IRPF ${year} com o Asvid!`,
    };
  }

  return {
    title: intl.formatMessage({
      defaultMessage: "Comunidade Black",
      id: "YlaL/t",
    }),
    description: intl.formatMessage({
      defaultMessage:
        "Crie um tópico abaixo e tire suas dúvidas com os mentores Eduardo e Asvid, além de outros Blacks!",
      id: "MPupJy",
    }),
  };
}
